module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAg0lEQVQ4T63UMQ6AMAgFULiBR/MGxqGsXsWdxZtiGGpMrPBJytSlry38lKlYInKZ2aKq63srVxxHiGgzs11Vff0UDEWIaxCUIRCEICmEIiFUQX6hKjKEWmsnMx+jEUdR+UxtGuSnTnlav34VCwNZwdJko1gKoT2DIASDoQwrQR0bfWw3IYuOEx+y2q4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/lawColumn/backicon.png
// module id = AwTu
// module chunks = 0